module.exports = __webpack_public_path__ + "static/slider_a-c1332b9e3a9399915555b8e3faf2f7a2.png";